import { css } from '@emotion/css';

export const defaultStyles = {
  pageRoot: css`
    height: 100%;
    width: 100%;
  `,
  pageInner: css`
    height: calc(100% - 80px);
    width: 100%;
    overflow-y: scroll;
    scrollbar-width: 0;
    ::-webkit-scrollbar {
      display: none;
    }
  `,
  itemRoot: css`
    width: 100%;
  `,
  itemCamName: css`
  `,
  itemSlideRoot: css`
    overflow-y: auto;
    scrollbar-width: 0;
    ::-webkit-scrollbar {
      display: none;
    }
    /* scroll-snap-type: x mandatory; */

    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-left: 16px
  `,
  itemSlideItem: css`
    scroll-snap-align: start;
    /* position: relative; */
  `,
  itemDescriptionTop: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
  itemGroupedCount: css`
  `,
  itemSlideItemImage: css`
    width: calc(90vw - 20px);
  `,
} as const;
